var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("config-menu"),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("modal", {
            ref: "confirm",
            on: {
              ok: function($event) {
                return _vm.signOutCompany()
              }
            }
          }),
          _vm._v(" "),
          _c("h2", [_vm._v("退会前にお読みください")]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-sm mt-1",
              on: {
                click: function($event) {
                  return _vm.$refs.confirm.confirm("本当に退会しますか？")
                }
              }
            },
            [_vm._v("退会する\n      ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "[注意]ユーザ、休暇申請、交通費、勤怠など紐づくすべてのデータが削除されます。\n        "
      ),
      _c("br"),
      _vm._v("今月末までのご利用分が請求対象となります。\n      ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0be88d58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0be88d58","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/admin/config/ConfigSignOut.vue
// module id = 408
// module chunks = 0